// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckoutButton_wrapper__-g2sU","basket":"CheckoutButton_basket__uScL4","count":"CheckoutButton_count__14eJ-"};